import { render, staticRenderFns } from "./ArtistRecommendation.vue?vue&type=template&id=797d3636&scoped=true"
import script from "./ArtistRecommendation.vue?vue&type=script&lang=js"
export * from "./ArtistRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ArtistRecommendation.vue?vue&type=style&index=0&id=797d3636&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d3636",
  null
  
)

export default component.exports